import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/2.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Przybycie do osady"
            question="W którą stronę pójdziesz?"
            audio={audio}
            answers={{
                ans1: "Do wiatraka.",
                ans2: "Do studni.",
            }}
            links={{
                link1: PAGES.p3,
                link2: PAGES.p4,
            }}
            content={
                <div>
                    <p>
                        Błotnista droga prowadzi cię na szczyt pagórka. Z każdym twoim krokiem zaczynają się wyłaniać budynki. No nareszcie, miasto! Dwie wieże kościołów, synagoga, wiatrak, drewniane chaty. Jest i jakaś murowana! Wszystkie są tak niskie, że przechodzące obok krowy mogłyby zajrzeć do środka i powiedzieć „dzień dobry”. Nieopodal kapliczka, studnia…
                        Pod wiatrakiem kręci się kilka osób, ale z drugiej strony dobrze byłoby uzupełnić wodę w manierce.
                    </p>
                </div>
            }
        />

    );
}